import { render } from "./404.vue?vue&type=template&id=f4e71bac"
const script = {}

import exportComponent from "/var/lib/docker/jenkins_home/workspace/play-spider-web-prod-s3-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__